import React, { Fragment } from 'react';
import TrackOrderState from './track-order-state';
import { OrderType } from 'models/order.model';
type Props = {
  order: OrderType;
  expand?: boolean;
};
const TrackOrderStatesGroup = ({ order }: Props) => {
  return (
    <Fragment>
      <TrackOrderState
        start
        time={order.created_at}
        text='Payment recieved'
        innerText={'Payment confirmation'}
      />
      {!order.cancelled ? (
        <Fragment>
          <TrackOrderState
            time={order.kitchen_accepted_time}
            text={
              order.kitchen_accepted
                ? 'Preparing your order'
                : 'Waiting for kitchen to start your order'
            }
            innerText={
              order.kitchen_prepared ? 'Your order has been prepared' : 'Preparing your order'
            }
          />
          <TrackOrderState
            time={order.kitchen_dispatched_time}
            text={order.rider_assigned ? 'Order is in transit' : 'Order is ready'}
            innerText={
              order.rider_assigned ? 'Your order is on the way' : 'Waiting for rider to be assigned'
            }
          />
          <TrackOrderState
            end
            time={order.completed_time}
            text='Order completed'
            innerText={
              order.completed_time
                ? 'Your order has been completed'
                : 'Order has not been completed'
            }
          />
        </Fragment>
      ) : (
        <TrackOrderState
          time={order.cancelled_time}
          text='Order cancelled'
          end
          isCancelled
          innerText='Order was canceled'
        />
      )}
    </Fragment>
  );
};

export default TrackOrderStatesGroup;
